module.exports = __webpack_public_path__ + "static/media/furniture-4.4c0b0cba.jpg";